import { render } from "./MySeparator.vue?vue&type=template&id=3cc4cbfa&scoped=true"
const script = {}

import "./MySeparator.vue?vue&type=style&index=0&id=3cc4cbfa&scoped=true&lang=scss"

import exportComponent from "/home/teamcity-agent/agent3/work/1e41b97f3be6577f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc4cbfa"]])

export default __exports__